import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as qs from 'qs';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { alunoResponse } from '../../../../models/alunos.interface';
import { chamada } from '../../../../models/chamada.interface';
import { frequencia } from '../../../../models/frequencia.interface';
import { PaginacaoResponse } from '../../../../models/paginacaoResponse.interface';
import {
  listarPaginacao,
  Post,
  SingleResponse,
} from '../../../../models/rest.interface';
import TurmaRequest, {
  GradeCurricular,
  Turma,
  turmaResponse,
} from '../../../../models/turma.interface';
import { UserService } from '../../../../shared/services/user/user.service';
import { CursosService } from '../cursos/cursos.service';
import {
  gradeCurricularRequest,
  observacaoGradeCurricular,
  observacaoGradeCurricularResponse,
} from './../../../../models/turma.interface';

const URL = environment.BACKEND_API + '/turmas';
const URL_BASE = environment.BACKEND_API;
@Injectable({
  providedIn: 'root',
})
export class TurmasService {
  private turmaSubject: BehaviorSubject<any> = new BehaviorSubject(null);

  infos_chamada = new BehaviorSubject<realizarChamada>({
    materiaId: null,
    turmaId: null,
  });
  mediaCurso!: number;
  materiaId = new BehaviorSubject<any>(null);
  escolaId!: number;
  idUser!: number;
  idCurso!: number;
  idMateria!: number;
  idChamada!: string;
  constructor(
    private readonly http: HttpClient,
    private readonly userService: UserService,
    private readonly cursoService: CursosService,
  ) {
    this.userService.escola.subscribe((value) => {
      if (value !== undefined) {
        this.escolaId = value.id;
      }
    });
    this.idUser = this.userService.user?.id;
    this.materiaId.subscribe((value) => {
      this.idMateria = value;
    });
  }

  get getTurma(): any {
    return this.turmaSubject.getValue();
  }

  setTurma(turma: any) {
    this.turmaSubject.next(turma);
  }

  buscarTurmaParaObservacao(documentIdTurma: string): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          ativo: { $eq: true },
        },
        populate: {
          alunos: {
            populate: {
              users: true,
            },
          },
          users: true,
        },
      },
      { encodeValuesOnly: true },
    );

    return this.http.get<any>(`${URL}/${documentIdTurma}/?${query}`);
  }

  salvarTurma(
    turmaRequest: Post<TurmaRequest>,
  ): Observable<SingleResponse<any>> {
    return this.http.post<SingleResponse<any>>(`${URL}`, turmaRequest);
  }

  buscarAlunoPorTurma(): Observable<SingleResponse<alunoResponse>> {
    return this.http.get<SingleResponse<alunoResponse>>(
      `${URL_BASE}/alunos/?filters[turma][$eq]=${this.turmaSubject.getValue().id}`,
    );
  }

  desativarTurma(
    documentId: string,
    turma: any,
  ): Observable<SingleResponse<turmaResponse>> {
    return this.http.put<any>(`${URL}/${documentId}`, turma);
  }

  salvarDesvinculacaoAluno(form: Post<any>): Observable<any> {
    return this.http.post(`${URL_BASE}/motivo-desistencias`, form);
  }

  listarPorEscolas(
    params: listarPaginacao = {},
  ): Observable<PaginacaoResponse<Turma>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<PaginacaoResponse<Turma>>(
      `${URL}/?filters[escola][$eq]=${this.escolaId}&filters[ativo][$eq]=true`,
      { params: httpParams },
    );
  }

  buscarTurmaPor(find: string): Observable<SingleResponse<Turma>> {
    return this.http.get<SingleResponse<Turma>>(
      `${URL}/?filters[escola][$eq]=${this.escolaId}&filters[$and][1][nome][$containsi]=${find}`,
    );
  }

  buscarFrequenciasAPP(
    idAluno: any,
    anoLetivo: any,
  ): Observable<SingleResponse<frequencia[]>> {
    return this.http.get<SingleResponse<frequencia[]>>(
      `${URL_BASE}/frequencias/?filters[$and][0][alunos][$eq]=${idAluno}&filters[$and][1][createdAt][$containsi]=${anoLetivo}`,
    );
  }

  listarTurmasDoProfessor(
    params: listarPaginacao = {},
    idProfessor: number,
  ): Observable<PaginacaoResponse<Turma>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<PaginacaoResponse<Turma>>(
      `${URL}/?filters[$and][0][escola][$eq]=${this.escolaId}&filters[$and][1][users][$eq]=${idProfessor}&filters[ativo][$eq]=true`,
      { params: httpParams },
    );
  }

  editarTurma(turmaRequest: Post<any>, documentId: string): Observable<any> {
    return this.http.put<any>(`${URL}/${documentId}`, turmaRequest);
  }

  buscarTurmaPorUser(user: number): Observable<SingleResponse<Turma>> {
    return this.http.get<SingleResponse<Turma>>(
      `${URL}/?filters[$and][0][escola][$eq]=${this.escolaId}&filters[$and][1][users][$eq]=${user}&populate=curso`,
    );
  }
  buscarTurmasPorAnoLetivo(ano: any): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          escola: {
            $eq: this.escolaId,
          },
          anoLetivo: {
            $eq: ano,
          },
          ativo: {
            $eq: true,
          },
        },
        populate: {
          alunos: true,
          curso: {
            populate: '*',
          },
          escola: true,
          frequencias: true,
          grade_curriculars: true,
          users: true,
        },
      },
      { encodeValuesOnly: true },
    );

    return this.http.get<any>(`${URL}/?${query}`);
  }

  buscarTurmaParaRelatorio(documentId: any): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          documentId: {
            $eq: documentId,
          },
        },
        populate: {
          alunos: true,
          curso: {
            populate: '*',
          },
          escola: true,
          frequencias: true,
          grade_curriculars: true,
          users: true,
        },
      },
      { encodeValuesOnly: true },
    );

    return this.http.get<any>(`${URL}/?${query}`);
  }

  buscarTurmaParaRelatorioNotas(
    documentId: any,
    materia: number,
    periodo: any,
    turma: number,
  ): Observable<any> {
    const query = qs.stringify(
      {
        populate: {
          alunos: {
            populate: {
              notas: {
                filters: {
                  periodo: {
                    $eq: periodo,
                  },
                  materia: {
                    $eq: materia,
                  },
                  turma: {
                    $eq: turma,
                  },
                },
                populate: 'tipo_avaliacao',
              },
            },
          },
          escola: true,
          users: true,
          curso: {
            populate: {
              tipo_avaliacaos: true,
            },
          },
        },
      },
      { encodeValuesOnly: true },
    );
    return this.http.get<any>(`${URL}/${documentId}/?${query}`);
  }

  salvarGradeCurricular(
    gradeRequest: Post<gradeCurricularRequest>,
  ): Observable<SingleResponse<GradeCurricular>> {
    gradeRequest.data.user = this.idUser;
    gradeRequest.data.turma = this.turmaSubject.getValue().id;
    gradeRequest.data.materia = this.idMateria;

    return this.http.post<SingleResponse<GradeCurricular>>(
      `${URL_BASE}/grade-curriculars`,
      gradeRequest,
    );
  }

  desativarConteudo(
    documentId: string,
    grade: any,
  ): Observable<SingleResponse<any>> {
    return this.http.put<any>(
      `${URL_BASE}/grade-curriculars/${documentId}`,
      grade,
    );
  }

  buscarTurmaPorId(documentId: string): Observable<any> {
    return this.http.get<any>(
      `${URL}/${documentId}/?filters[escola][$eq]=${this.escolaId}&populate=alunos&populate=users&populate=curso`,
    );
  }

  buscarTurmaInit(documentId: string): Observable<any> {
    return this.http.get<any>(
      `${URL}/${documentId}/?filters[escola][$eq]=${this.escolaId}&populate=curso`,
    );
  }

  buscarTurmaAbaUsers(documentId: string): Observable<any> {
    return this.http.get<any>(
      `${URL}/${documentId}/?populate[users][populate][0]=materias&populate[users][populate][1]=permissaos`,
    );
  }

  buscarTurmaPorIdMontarNotas(
    documentId: string,
    periodo: string,
    materia: number,
    turmaId: number,
  ): Observable<any> {
    const query = qs.stringify(
      {
        populate: {
          curso: {
            populate: 'tipo_avaliacaos',
          },
          alunos: {
            populate: {
              notas: {
                filters: {
                  turma: {
                    $eq: turmaId,
                  },
                  periodo: {
                    $eq: periodo,
                  },
                  materia: {
                    $eq: materia,
                  },
                },
                populate: {
                  aluno: true,
                  tipo_avaliacao: true,
                },
              },
            },
          },
        },
      },
      { encodeValuesOnly: true },
    );

    return this.http.get<any>(`${URL}/${documentId}/?${query}`);
  }

  buscarTurmaPorIdMontarNotasAluno(
    documentId: string,
    periodo: string,
    materia: number,
    turmaId: number,
    idAluno: string,
  ): Observable<any> {
    const query = qs.stringify(
      {
        populate: {
          curso: {
            populate: 'tipo_avaliacaos',
          },
          alunos: {
            filters: {
              id: { $eq: idAluno },
            },
            populate: {
              notas: {
                filters: {
                  turma: {
                    $eq: turmaId,
                  },
                  periodo: {
                    $eq: periodo,
                  },
                  materia: {
                    $eq: materia,
                  },
                },
                populate: {
                  aluno: true,
                  tipo_avaliacao: true,
                },
              },
            },
          },
        },
      },
      { encodeValuesOnly: true },
    );
    return this.http.get<any>(`${URL}/${documentId}/?${query}`);
  }

  buscarTurmaPorAluno(documentId: string, alunoId: string): Observable<any> {
    return this.http.get<any>(
      `${URL}/${documentId}/?filters[escola][$eq]=${this.escolaId}&populate[alunos][filters][documentId][$eq]=${alunoId}&populate=curso`,
    );
  }

  buscarTurmaPorIdRELATORIO(documentId: string): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          escola: {
            $eq: this.escolaId,
          },
        },
        populate: {
          curso: {
            populate: 'materias',
          },
          escola: true,
          alunos: {
            populate: 'users',
          },
        },
      },
      { encodeValuesOnly: true },
    );

    return this.http.get<any>(`${URL}/${documentId}/?${query}`);
  }

  buscarTurmaComponentNotas(documentId: string): Observable<any> {
    return this.http.get<any>(
      `${URL}/${documentId}/?filters[escola][$eq]=${this.escolaId}&populate[0]=curso&populate[1]=alunos`,
    );
  }

  buscarGradeCurricularPorMateria(
    idMateria: number,
  ): Observable<SingleResponse<GradeCurricular>> {
    return this.http.get<SingleResponse<GradeCurricular>>(
      `${URL_BASE}/grade-curriculars/?filters[materia][$eq]=${idMateria}&populate=*`,
    );
  }

  buscarGradeCurricularPorMateriaETurma(
    idMateria: number,
    idTurma: number,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<GradeCurricular>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<SingleResponse<GradeCurricular>>(
      `${URL_BASE}/grade-curriculars/?filters[$and][0][materia][$eq]=${idMateria}&filters[$and][1][ativo][$eq]=true&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  buscarGradeCurricularPorMateriaETurmaData(
    idMateria: number,
    data: any,
  ): Observable<SingleResponse<GradeCurricular>> {
    return this.http.get<SingleResponse<GradeCurricular>>(
      `${URL_BASE}/grade-curriculars/?filters[$and][0][materia][$eq]=${idMateria}&filters[$and][1][data][$containsi]=${data}&sort=createdAt:desc&populate=observacao_turmas`,
    );
  }

  buscarGradeCurricularPorId(
    idGrade: string,
  ): Observable<SingleResponse<GradeCurricular>> {
    return this.http.get<SingleResponse<GradeCurricular>>(
      `${URL_BASE}/grade-curriculars/?filters[documentId][$eq]=${idGrade}&populate=*`,
    );
  }

  salvarObservacaoTurma(
    obs: Post<observacaoGradeCurricular>,
  ): Observable<SingleResponse<observacaoGradeCurricularResponse>> {
    return this.http.post<SingleResponse<observacaoGradeCurricularResponse>>(
      `${URL_BASE}/observacao-turmas`,
      obs,
    );
  }

  buscarGradeCurricularPor(
    find: string,
    idMateria: number,
  ): Observable<SingleResponse<GradeCurricular>> {
    return this.http.get<SingleResponse<GradeCurricular>>(
      `${URL_BASE}/grade-curriculars/?filters[$and][0][materia][$eq]=${idMateria}&filters[$and][1][conteudo][$containsi]=${find}`,
    );
  }

  buscarFrequenciasPorMateriaTurmaEscola(
    idMateria: number,
    idTurma: number,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<any>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/frequencias/?filters[$and][0][materias][$eq]=${idMateria}&filters[$and][1][turmas][$eq]=${idTurma}&populate=*&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  buscarFrequenciasPorGrade(
    idGrade: any,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<any>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10000).toString());
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/frequencias/?filters[$and][0][grade_curriculars][$eq]=${idGrade}&populate=*&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  buscarFrequenciasPorGradeEData(
    idGrade: any,
    data: any,
    idTurma: number,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<any>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10000).toString());
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/frequencias/?filters[$and][0][grade_curriculars][$eq]=${idGrade}&filters[$and][1][data][$containsi]=${data}&filters[$and][2][turmas][$eq]=${idTurma}&populate=*&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  buscarFrequenciaPorId(documentId: any): Observable<frequencia> {
    return this.http.get<frequencia>(`${URL_BASE}/frequencias/${documentId}`);
  }

  editarFrequencia(frequencia: Post<any>, idFrequencia: any): Observable<any> {
    return this.http.put<any>(
      `${URL_BASE}/frequencias/${idFrequencia}`,
      frequencia,
    );
  }

  buscarFrequenciasPorMateriaTurmaEscolaAluno(
    idMateria: number,
    idTurma: number,
    find: string,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<any>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10000).toString());
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/frequencias/?filters[$and][0][materias][$eq]=${idMateria}&filters[$and][1][turmas][$eq]=${idTurma}&filters[$and][2][grade_curriculars][conteudo][$containsi]=${find}&populate=*&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  buscarFrequenciasPorMateriaTurmaEscolaPorData(
    idMateria: number,
    idTurma: number,
    dataHoje: any,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<any>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/frequencias/?filters[$and][0][materias][$eq]=${idMateria}&filters[$and][1][turmas][$eq]=${idTurma}&filters[$and][2][data][$containsi]=${dataHoje}&populate=*&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  buscarFrequenciasPorMateriaTurmaEscolaPorDataAluno(
    idMateria: number,
    idTurma: number,
    dataHoje: any,
    idAluno: any,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<any>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/frequencias/?filters[$and][0][materias][$eq]=${idMateria}&filters[$and][1][turmas][$eq]=${idTurma}&filters[$and][2][data][$containsi]=${dataHoje}&filters[$and][3][alunos][$eq]=${idAluno}&populate=*&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  buscarFrequenciasPorMateriaTurmaEscolaPorDataAlunoGrade(
    idMateria: number,
    idTurma: number,
    idAluno: any,
    grade: any,
    params: listarPaginacao = {},
  ): Observable<SingleResponse<any>> {
    let httpParams = new HttpParams()
      // .set('sort', params.sort || 'descending')
      .set('pagination[withCount]', 'true')
      .set('pagination[page]', (params.page ?? 1).toString())
      .set('pagination[pageSize]', (params.pageSize ?? 10).toString());
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/frequencias/?filters[$and][0][materias][$eq]=${idMateria}&filters[$and][1][turmas][$eq]=${idTurma}&filters[$and][2][alunos][$eq]=${idAluno}&filters[$and][3][grade_curriculars][conteudo][$containsi]=${grade}&populate=*&sort=createdAt:desc`,
      { params: httpParams },
    );
  }

  getCurrentDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${year}-${month}-${day}`;
  }

  editarGradeCurricular(
    grade: Post<gradeCurricularRequest>,
    idGrade: string,
  ): Observable<SingleResponse<GradeCurricular>> {
    return this.http.put<SingleResponse<GradeCurricular>>(
      `${URL_BASE}/grade-curriculars/${idGrade}`,
      grade,
    );
  }

  vincularAluno(turmaRequest: Post<any>): Observable<any> {
    return this.http.put<any>(
      `${URL}/${this.turmaSubject.getValue().documentId}`,
      turmaRequest,
    );
  }

  vincularColaboradores(colaboradores: Post<any>): Observable<any> {
    return this.http.put<any>(
      `${URL}/${this.turmaSubject.getValue().documentId}`,
      colaboradores,
    );
  }

  salvarChamada(chamada: Post<chamada>): Observable<SingleResponse<any>> {
    return this.http.post<SingleResponse<any>>(
      `${URL_BASE}/frequencias`,
      chamada,
    );
  }

  editarObservacao(observacao: Post<any>, documentId: string): Observable<any> {
    return this.http.put<any>(
      `${URL_BASE}/observacao-turmas/${documentId}`,
      observacao,
    );
  }

  buscarObservacao(value: string, grade: string): Observable<any> {
    const query = qs.stringify(
      {
        filters: {
          grade_curricular: {
            documentId: {
              $eq: grade,
            },
          },
          observacao: {
            $containsi: value,
          },
        },
        populate: {
          user: true,
        },
      },
      { encodeValuesOnly: true },
    );
    return this.http.get<any>(`${URL_BASE}/observacao-turmas/?${query}`);
  }

  buscarObservacoesPorGrade(
    documentId: string,
  ): Observable<SingleResponse<any>> {
    const query = qs.stringify(
      {
        filters: {
          documentId: {
            $eq: documentId,
          },
          ativo: {
            $eq: true,
          },
        },
        populate: {
          observacao_turmas: {
            populate: {
              user: true,
            },
          },
        },
      },
      { encodeValuesOnly: true },
    );
    return this.http.get<SingleResponse<any>>(
      `${URL_BASE}/grade-curriculars/${documentId}?${query}`,
    );
  }

  buscarTurmaAbaNotas(documentId: string): Observable<SingleResponse<any>> {
    const query = qs.stringify(
      {
        filters: {
          documentId: {
            $eq: documentId,
          },
          ativo: {
            $eq: true,
          },
        },
        populate: {
          curso: {
            populate: {
              materias: {
                populate: true,
              },
            },
          },
        },
      },
      { encodeValuesOnly: true },
    );
    return this.http.get<SingleResponse<any>>(`${URL}/${documentId}?${query}`);
  }

  buscarTurmaAbaGradeCurricular(
    documentId: string,
  ): Observable<SingleResponse<any>> {
    const query = qs.stringify(
      {
        filters: {
          documentId: {
            $eq: documentId,
          },
          ativo: {
            $eq: true,
          },
        },
        populate: {
          curso: {
            populate: {
              materias: {
                populate: {
                  grade_curriculars: {
                    filters: {
                      ativo: {
                        $eq: true,
                      },
                    },
                    populate: {
                      observacao_turmas: {
                        populate: {
                          user: true,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      { encodeValuesOnly: true },
    );
    return this.http.get<SingleResponse<any>>(`${URL}/${documentId}?${query}`);
  }

  buscarTurma(
    documentId: string,
    idTurma: number,
  ): Observable<SingleResponse<any>> {
    const query = qs.stringify(
      {
        filters: {
          documentId: {
            $eq: documentId,
          },
          ativo: {
            $eq: true,
          },
        },
        populate: {
          curso: {
            populate: {
              materias: {
                populate: {
                  // grade_curriculars: {
                  //   filters: {
                  //     turma: {
                  //       $eq: idTurma,
                  //     },
                  //     ativo: {
                  //       $eq: true,
                  //     },
                  //   },
                  // },
                  frequencias: {
                    filters: {
                      turmas: {
                        $eq: idTurma,
                      },
                    },
                    populate: '*',
                  },
                  // notas: {
                  //   filters: {
                  //     turma: {
                  //       $eq: idTurma,
                  //     },
                  //   },
                  // },
                },
              },
            },
          },
          // alunos: true,
          // escola: true,
          // users: true,
        },
      },
      { encodeValuesOnly: true },
    );

    return this.http.get<SingleResponse<any>>(`${URL}/${documentId}?${query}`);
  }

  buscarTurmaFrequenciaPorData(
    documentId: string,
    idTurma: number,
    data: string,
  ): Observable<SingleResponse<any>> {
    const query = qs.stringify(
      {
        filters: {
          documentId: {
            $eq: documentId,
          },
          ativo: {
            $eq: true,
          },
        },
        populate: {
          curso: {
            populate: {
              materias: {
                populate: {
                  // grade_curriculars: {
                  //   filters: {
                  //     turma: {
                  //       $eq: idTurma,
                  //     },
                  //     ativo: {
                  //       $eq: true,
                  //     },
                  //   },
                  // },
                  frequencias: {
                    filters: {
                      turmas: {
                        $eq: idTurma,
                      },
                      data: {
                        $containsi: data,
                      },
                    },
                    populate: '*',
                  },
                  // notas: {
                  //   filters: {
                  //     turma: {
                  //       $eq: idTurma,
                  //     },
                  //   },
                  // },
                },
              },
            },
          },
          // alunos: true,
          // escola: true,
          // users: true,
        },
      },
      { encodeValuesOnly: true },
    );

    return this.http.get<SingleResponse<any>>(`${URL}/${documentId}?${query}`);
  }

  buscarTurmaAbaAlunos(documentId: string): Observable<any> {
    return this.http.get<any>(
      `${URL}/${documentId}/?populate[alunos][populate]=users`,
    );
  }
}

export interface stepsTurma {
  component: string;
  id: number | null;
  documentId: string | null;
}

export interface realizarChamada {
  turmaId: number | null;
  materiaId: number | null;
}
